import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import SelectBase, * as Select from '@segment/matcha/components/Select'
import type { UseSelectProps } from '@segment/matcha/components/Select/useSelect'
import useSelect from '@segment/matcha/components/Select/useSelect'
import Input from '@segment/matcha/components/Input'
import { ChevronDownIcon, ClearIcon } from '@segment/matcha/components/Icons/Common'
import type { Option } from '@segment/matcha/components/Menu/useMenu'

interface FilterSelectProps {
  options: Option[]
  id: UseSelectProps[`id`]
  onSelect: UseSelectProps[`onSelect`]
  placeholder?: string
  disabled?: boolean
}
const FilterSelect: FC<PropsWithChildren<FilterSelectProps>> = ({ options, id, onSelect, placeholder, disabled }) => {
  const { state, getControlProps, filteredOptions, getSelectProps } = useSelect({
    options,
    id,
    onSelect,
    config: {
      multiselect: true,
      mobileConfirmationBehaviour: true,
    },
  })

  return (
    <Wrapper>
      <Input
        name={id}
        type="search"
        resetable={state.filterValue !== ``}
        clearIcon={
          <Select.ClearSelect>
            <ClearIcon size="small" />
          </Select.ClearSelect>
        }
        rightSecondIcon={<ChevronDownIcon />}
        {...getControlProps({
          placeholder,
          counter: true,
        })}
        aria-label={placeholder}
        disabled={disabled}
      />
      <SelectBase
        id={`select-base-${id}`}
        name={`select-base-${id}`}
        options={options}
        filteredOptions={filteredOptions}
        displayMode={state.displayMode}
        open={state.open}
        listItemComponent={Select.MenuItemWithCheckbox}
        {...getSelectProps()}
      />
    </Wrapper>
  )
}

export default FilterSelect

const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.twilio.gray[80]};
  z-index: 1;
`
